import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
//import FMPText from './pureForm/FMPText';
import { withStyles } from '@material-ui/core/styles';

import AuthUserContainer from '../../containers/AuthUser';
import StationsContainer from '../../containers/Stations';
import FormComponent from '../../components/FormComponent';

const styles = () => {
	return {
		check: {
			color: '#4CAF50',
			width: 20,
			height: 20,
			verticalAlign: 'middle',
			paddingRight: 5,
		},
	};
};

class RailcarLinking extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			sent: false,
			isLookingUpStations: false,
			formFieldError: {},
			stationsWithSameNumber: undefined,
		};
	}

	handleSendPricingRequest = () => {
		const { station, showErrors, addPricingRequest } = this.props;
		const { stationsWithSameNumber } = this.state;
		//- Required fields
		const formFieldError = {};
		const errors = [];

		if (!_.isEmpty(errors)) {
			this.setState({ formFieldError });
			return showErrors(errors);
		}

		const params = {};
		if (_.isEmpty(stationsWithSameNumber)) {
			params.stationId = station.stationId;
		} else {
			params.multiStationIds = [station.stationId];
			stationsWithSameNumber.forEach((s) => {
				params.multiStationIds.push(s.stationId);
			});
		}

		this.setState({ sent: true });
		this.state.sent = true;

		addPricingRequest({
			params,
			callback: (err) => {
				if (err) {
					this.state.sent = false;
				}
			},
		});
	};

	render() {
		return (
			<Grid spacing={2} container style={{ alignItems: 'flex-start' }}>
				<Grid item xs={12} md={4} style={{ textAlign: 'left' }}>
					Work in progress
				</Grid>
			</Grid>
		);
	}

	renderStationsWithSameNumber = () => {
		const { stationsWithSameNumber } = this.state;
		if (_.isEmpty(stationsWithSameNumber)) {
			return <div>None shared</div>;
		}

		return stationsWithSameNumber.map((station) => {
			return (
				<div key={station.stationId}>
					{station.number} - {station.name}
				</div>
			);
		});
	};
}

RailcarLinking.propTypes = {
	station: PropTypes.object.isRequired,
	addPricingRequest: PropTypes.func.isRequired,
	searchStations: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	showErrors: PropTypes.func.isRequired,
};

RailcarLinking.defaultProps = {};

export default _.flow([withStyles(styles), AuthUserContainer, StationsContainer])(RailcarLinking);
